export const TIME_TAKEN = {
  driverPickup: 'DRIVER_PICKUP_TIME_TAKEN',
  driverDropoff: 'DRIVER_DROPOFF_TIME_TAKEN'
}

export default {
  TIME_TAKEN
}
